import React from 'react';

/**
 * LOGOTIPO OFICIAL MANKLAR
 * 
 * IMPORTANTE: Este componente usa exclusivamente el archivo de imagen oficial de Manklar.
 * 
 * NO MODIFICAR:
 * - No generar versiones alternativas
 * - No recrear el logo mediante IA
 * - No simplificar el diseño
 * - No sustituir por iconos similares
 * - No modificar colores, formas ni tipografía
 * 
 * Solo se permite ajustar el tamaño para mejorar la visibilidad.
 * 
 * VERSIONES:
 * - /manklar-logo-white.png → Para fondos OSCUROS (Portal Cliente, Landing)
 * - /manklar-logo-black.png → Para fondos CLAROS
 */

// Logo completo con icono del jaguar y texto MANKLAR - versión para fondo oscuro
export function ManklarLogoHorizontal({ size = 'default', className = '', variant = 'white' }) {
  const sizes = {
    small: { height: 32 },
    default: { height: 40 },
    large: { height: 56 },
    xlarge: { height: 72 }
  };
  
  const { height } = sizes[size] || sizes.default;
  const logoSrc = variant === 'black' ? '/manklar-logo-black.png' : '/manklar-logo-white.png';
  
  return (
    <img 
      src={logoSrc}
      alt="MANKLAR"
      style={{ height: `${height}px`, width: 'auto' }}
      className={`object-contain drop-shadow-[0_0_20px_rgba(255,255,255,0.1)] ${className}`}
      data-testid="manklar-logo-horizontal"
    />
  );
}

// Logo solo icono del jaguar (para espacios reducidos como favicon o iconos pequeños)
export function ManklarIcon({ size = 'default', className = '', variant = 'white' }) {
  const sizes = {
    small: { height: 24 },
    default: { height: 32 },
    large: { height: 48 },
    xlarge: { height: 64 }
  };
  
  const { height } = sizes[size] || sizes.default;
  const logoSrc = variant === 'black' ? '/manklar-logo-black.png' : '/manklar-logo-white.png';
  
  return (
    <img 
      src={logoSrc}
      alt="MANKLAR"
      style={{ 
        height: `${height}px`, 
        width: 'auto',
        objectFit: 'contain'
      }}
      className={className}
      data-testid="manklar-icon"
    />
  );
}

// Componente principal - Logo horizontal completo
export function ManklarLogo({ size = 'default', className = '', variant = 'white' }) {
  return <ManklarLogoHorizontal size={size} className={className} variant={variant} />;
}

// Export default también para compatibilidad
export default ManklarLogo;

// Versión vertical para usar donde se necesite más altura
export function ManklarLogoVertical({ size = 'default', className = '', variant = 'white' }) {
  const sizes = {
    small: { height: 48 },
    default: { height: 64 },
    large: { height: 96 },
    xlarge: { height: 128 }
  };
  
  const { height } = sizes[size] || sizes.default;
  const logoSrc = variant === 'black' ? '/manklar-logo-black.png' : '/manklar-logo-white.png';
  
  return (
    <img 
      src={logoSrc}
      alt="MANKLAR"
      style={{ height: `${height}px`, width: 'auto' }}
      className={`object-contain ${className}`}
      data-testid="manklar-logo-vertical"
    />
  );
}
